export const idlFactory = ({ IDL }) => {
  const QuerioSEAnalitycs = IDL.Service({
    'balance' : IDL.Func([], [IDL.Nat], ['query']),
    'get_analitycs' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64))],
        ['query'],
      ),
    'get_chains_analitycs' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Nat, IDL.Nat64))],
        ['query'],
      ),
    'get_total_keys' : IDL.Func([], [IDL.Nat], ['query']),
    'get_total_queries' : IDL.Func([], [IDL.Nat64], ['query']),
    'search' : IDL.Func([IDL.Text, IDL.Nat], [], []),
  });
  return QuerioSEAnalitycs;
};
export const init = ({ IDL }) => { return []; };
